export default "__VITE_ASSET__x$z10Z$R__"